import React, { useState } from "react";

import CustomChip from "../../../shared/CustomChip";
import { useTranslation } from "react-i18next";
import { MdAccessTime, MdCancel, MdEditNote, MdNoteAdd, MdOutlineAdd, MdOutlineCancel } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedVisitData } from "../../../redux/slices/VisitsSlice";
import ReusableModal from "../../../shared/ReuseableModal";
import moment from "moment";
import CheckPermission from "../../../hooks/CheckPermission";
import { useNavigate } from "react-router-dom";
import {
  setIsGeneralSearch,
  setSelectPatientData,
} from "../../../redux/slices/BeneficiarySlice";
import { CancelVisitForm } from "./VisitDetail";
import ViewSickeLeaveReport from "../../../pages/HIS/patient-profiling/ViewSickeLeaveReport";
import DropdownField from "../../../shared/DropdownField";
import { fetchData } from "../../../helpers/fetchData";
import { isBusiness42Receptionist } from "../../../utils/businessLevelAccess";
import { canEditEmr } from "../../../utils/emrAccess";
import {
  FaBox,
  FaBriefcaseMedical,
  FaFemale,
  FaFileInvoiceDollar,
  FaFilePrescription,
  FaFlask,
  FaMale,
  FaPills,
  FaXRay,
} from "react-icons/fa";
import EmrDetails from "../patient-profile/EMRDetails";
import Prescription from "../patient-profile/Prescription";
import ClinicalOrderReport, {
  getClinicalOrderItems,
} from "../patient-profile/ClinicalOrderReport";
import { navigateSecurely } from "../../../utils/secureNavigation";
import { FaMoneyBill1Wave, FaRoute } from "react-icons/fa6";
import { formatDate, formatDateTime } from "../../../utils/FormateDateTime";
import ViewItems from "./ViewItems";
import { IoTimeOutline } from "react-icons/io5";
import ExtednVisitTime from "./ExtednVisitTime";
import { CalculateAge } from "../../../utils/CalculateAge";
import ActionButton from "./ActionButton";
import TrackingContent from "./TrackingContent";
import PatientJourneyModal from "./PatientJourneyModal";
import VisitCreateActionsMenu from "./VisitCreateActionsMenu";

const MixedAppointmentVisitCard = ({
  slotData,
  mixedData,
  getVisitDataPayload,
  order,
  getOrdersPayload,
  visitColor,
  visitCategory,
  orderData,
}) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openCancelVisitModal, setOpenCancelVisitModal] = useState(false);
  const [viewEmrLoading, setViewEmrLoading] = useState(false);
  const [viewItems, setViewItems] = useState(false);
  const [viewSickLeave, setViewSickLeave] = useState(false);
  const [selectedEmrData, setSelectedEmrData] = useState(null);
  const [openViewEmrModal, setOpenViewEmrModal] = useState(false);
  const [viewVisitTrack, setViewVisitTrack] = useState(false);
  const [trackId, setTrackId] = useState(null);
  const [viewJourney, setViewJourney] = useState(false);
  const [openViewPrescriptionModal, setOpenViewPrescriptionModal] =
    useState(false);
  const [clinicalOrderReportType, setClinicalOrderReportType] = useState(null);
  const [extendModal, setExtendModal] = useState(false);
  const [extendedVisit, setExtendedVisit] = useState(null);
  const isDoc = useSelector(
    (state) => state.auth.user?.role?.name_en == "Practitioner"
  );
  const isReceptionist = useSelector(
    (state) => state.auth.user?.role?.name_en == "Receptionist"
  );
  const authUser = useSelector((state) => state.auth.user);
  const isBusiness42ReceptionistUser = isBusiness42Receptionist(authUser);
  const isNurse = useSelector(
    (state) => state.auth.user?.role?.name_en == "Nurse"
  );
  const { hasPermission } = CheckPermission();
  const endDateTimeStr =
    moment(mixedData?.visit_date).format("YYYY-MM-DD") +
    " " +
    slotData?.end_time;
  const endTime = moment(endDateTimeStr, "YYYY-MM-DD HH:mm");
  const currentTime = moment();
  const isPadiItemExits = mixedData?.items?.some(
    (data) => data?.status == "Paid"
  );
  const emrCreationCheck = isNurse ? isPadiItemExits : true;

  const handlePayBill = () => {
    let date = moment(getVisitDataPayload?.start_date).format("YYYY-MM-DD");
    let start_time = slotData?.time;
    let end_time = slotData?.end_time;
    let day = moment(getVisitDataPayload?.start_date).format("dddd");
    let selectedPractitionerId = getVisitDataPayload?.practitioner_id;
    navigate("/pay-bill", {
      state: {
        start_time,
        day,
        date,
        selectedPractitionerId,
        isPayBill: true,
        billingVisitData: mixedData,
        end_time,
      },
    });
  };

  const handleNavigateCreateVisit = () => {
    let payment_status =
      mixedData?.payment_status == "Paid" ? "paid" : "unpaid";
    let date = moment(getVisitDataPayload?.start_date).format("YYYY-MM-DD");
    let start_time = slotData?.time;
    let end_time = slotData?.end_time;
    let day = moment(getVisitDataPayload?.start_date).format("dddd");
    let selectedPractitionerId = getVisitDataPayload?.practitioner_id;
    if (order) {
      navigate("/create-special-visit", {
        state: {
          orderData: orderData,
          getOrdersPayload: getOrdersPayload,
          start_time,
          day,
          date,
          end_time,
        },
      });
    } else {
      navigate("/create-visit", {
        state: {
          start_time,
          day,
          date,
          end_time,
          selectedPractitionerId,
          payment_status,
          patientDetails: mixedData?.patient,
          appointment_id: mixedData?.appointment_id,
          tab: getVisitDataPayload?.visit_category,
        },
      });
    }
  };

  const handleViewEmrDetails = async (emrNumber) => {
    setViewEmrLoading(true);
    let payload = { emr_id: Number(emrNumber), visit_id: mixedData?.visit_id, patient_id: mixedData?.patient?.patient_id };
    let response = await fetchData("POST", "/v3/emr/getById", payload);
    setViewEmrLoading(false);
    if (response?.data) {
      setOpenViewEmrModal(true);
      setSelectedEmrData(response?.data);
    } else {
      setSelectedEmrData(null);
    }
  };

  const handlePrescriptionDetails = async (emrNumber) => {
    setViewEmrLoading(true);
    let payload = { emr_id: Number(emrNumber), visit_id: mixedData?.visit_id, patient_id: mixedData?.patient?.patient_id };
    let response = await fetchData("POST", "/v3/emr/getById", payload);
    setViewEmrLoading(false);
    if (response?.data) {
      setOpenViewPrescriptionModal(true);
      setSelectedEmrData(response?.data);
    } else {
      setSelectedEmrData(null);
    }
  };
  const handleClinicalOrderDetails = async (reportType) => {
    setViewEmrLoading(true);
    const payload = { visit_id: mixedData?.visit_id, patient_id: mixedData?.patient?.patient_id };
    const response = await fetchData("POST", "/v3/emr/getClinicalOrderItems", payload);
    setViewEmrLoading(false);
    if (getClinicalOrderItems(response?.data?.items, reportType).length > 0) {
      setSelectedEmrData(response.data);
      setClinicalOrderReportType(reportType);
    } else {
      setSelectedEmrData(null);
    }
  };

  const isEmergencyVisit =
    mixedData?.priority?.coding?.[0]?.code?.toLowerCase() === "em" ||
    mixedData?.priority?.coding?.[0]?.display?.toUpperCase() === "EMERGENCY";
  const isCancelledVisit =
    mixedData?.status?.toLowerCase() === "cancelled" ||
    slotData?.appointment?.status?.toLowerCase() === "cancelled";
  const cardVisitColor = isCancelledVisit
    ? "!bg-red-200"
    : isEmergencyVisit
      ? "!bg-orange-200"
      : visitColor;

  return (
    <>
      {visitCategory == mixedData?.visit_category ||
        (mixedData.visit_category === "special_patient" &&
          visitCategory === "out_patient") ? (
        <div className="flex flex-col lg:flex-row w-full min-w-0 items-stretch min-h-auto relative bg-white overflow-hidden ">
          <div className="flex-1 lg:flex-[1] min-w-0 flex flex-col border-b lg:border-b-0 bg-white">
            <div className={`w-full h-auto min-h-[50px] flex flex-wrap items-center gap-2 px-3 cursor-pointer py-1 ${cardVisitColor}`}
              onClick={() => {
                let patientData = { ...mixedData?.patient, visit_id: mixedData?.visit_id };
                dispatch(setIsGeneralSearch(false));
                dispatch(setSelectPatientData(patientData));
                dispatch(setSelectedVisitData(mixedData));
                navigate("/patient-profile/overview");
              }}
            >
              <span
                className={`flex items-center justify-center w-6 h-6 rounded-full 
                            ${mixedData?.patient?.gender === 'female'
                    ? 'bg-rose-100 text-rose-600'
                    : mixedData?.patient?.gender === 'male'
                      ? 'bg-sky-100 text-sky-600'
                      : null
                  }`}
              >
                {mixedData?.patient?.gender === 'female' ? (
                  <FaFemale size={18} />
                ) : mixedData?.patient?.gender === 'male' ? (
                  <FaMale size={18} />
                ) : null}
              </span>
              <span className="text-[15px] font-bold text-gray-700 uppercase truncate flex-1 min-w-0 leading-none" title={`${t("MRN")}: ${mixedData?.patient?.file_no}${mixedData?.patient?.old_file_no ? `, ${t("Old MRN")}: ${mixedData?.patient?.old_file_no}` : ""}`}>
                {mixedData?.patient?.full_name || mixedData?.participant} ({mixedData?.patient?.file_no}{mixedData?.patient?.old_file_no ? <span> / {t("Old MRN")}: <span className="text-red-500">{mixedData?.patient?.old_file_no}</span></span> : ""})
              </span>
            </div>

            <div className="px-4 py-2 flex-1 flex items-center min-h-[50px] bg-white">
              <div className="flex flex-wrap items-center gap-3">

                <span className="text-[13px] font-semibold text-gray-800">
                  {mixedData?.patient?.document_id || "--"}
                </span>

                {mixedData?.patient?.dob && (
                  <>
                    <span className="text-gray-300 font-light">|</span>
                    <span className="text-[13px] font-medium text-gray-600 whitespace-nowrap">
                      {CalculateAge(mixedData?.patient?.dob)}
                    </span>
                  </>
                )}

                <span className="text-gray-300 font-light">|</span>
                <div className="flex items-center gap-1.5 text-gray-500">
                  <MdAccessTime size={14} className="text-gray-400" />
                  <span className="text-[13px] font-medium">
                    {formatDateTime(mixedData?.visit_date)}
                  </span>
                </div>

                {(mixedData?.nursing_status === "ready" || mixedData?.nursing_status === "with_nurse") && mixedData?.called_at && (
                  <>
                    <span className="text-gray-300 font-light">|</span>
                    <div className="flex items-center gap-1.5 text-emerald-600">
                      <i className="pi pi-check-circle text-[14px]"></i>
                      <span className="text-[13px] font-medium whitespace-nowrap">
                        {t("Triaged By")}: {mixedData?.called_by?.name} - {formatDateTime(mixedData?.called_at)}
                      </span>
                    </div>
                  </>
                )}

                {mixedData?.referral && (
                  <>
                    <span className="text-gray-300 font-light">|</span>
                    <div className="flex items-center gap-1.5 text-blue-600">
                      <span className="text-[13px] font-medium whitespace-nowrap">
                        {t("Referral")}: {mixedData.referral.auth_ref || "--"}
                        {mixedData.referral.valid_until && (
                          <>
                            {" - "}
                            {t("Valid Until")}:{" "}
                            {formatDate(mixedData.referral.valid_until)}
                          </>
                        )}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-2 px-3 py-2 border-t border-gray-100 mt-auto bg-gray-50/50 h-auto min-h-[45px]">
              <p className="text-[11px] font-semibold text-gray-700 px-2 py-0.5 bg-gray-100 rounded uppercase">
                {t(mixedData?.visit_payment_type) || t("Cash")}
              </p>

              <div className="h-3 w-[1px] bg-gray-200"></div>
              <p className="text-[11px] font-semibold text-gray-500 uppercase">
                {t("EP")}: {mixedData?.episode_id || "--"}
              </p>
              {/* <div className="h-3 w-[1px] bg-gray-200"></div> */}
              {/* <div
                className={`flex items-center justify-center w-5 h-5 rounded-full ${["s", "em"].includes(mixedData?.priority?.coding?.[0]?.code)
                  ? "bg-rose-100 text-rose-600"
                  : ["Follow Up", "Follow up"].includes(mixedData?.episode_type)
                    ? "bg-yellow-100 text-yellow-600"
                    : "bg-sky-100 text-sky-600"
                  }`}
              >
                <p className="text-[10px] !font-bold leading-none">
                  {mixedData?.token?.token_number || 1}
                </p>
              </div> */}
            </div>
          </div>

          <div className="flex-1 min-w-0 flex flex-col bg-white">
            <div className={`w-full h-auto min-h-[50px] flex flex-wrap items-center justify-end gap-1.5 px-3 py-1 ${cardVisitColor}`}>
              <div className="flex flex-wrap items-center gap-1.5 flex-1 min-w-0 justify-end">
                <CustomChip
                  chipType="mono-light"
                  showActionIcon={true}
                  label={t("Track")}
                  onClick={() => {
                    setViewItems(true);
                    setSelectedEmrData(mixedData);
                  }}
                  className="cursor-pointer whitespace-nowrap transition-all !bg-gray-50 !text-gray-500 !border-gray-200"
                  labelClassName="!text-[12px] !uppercase"
                />
                {mixedData?.appointment_id && (
                  <CustomChip
                    chipType="mono-light"
                    showActionIcon={true}
                    label={t("Track App")}
                    onClick={() => {
                      navigate(`/appointment-history/${mixedData?.appointment_id}`, {
                        state: { rowData: mixedData },
                      });
                    }}
                    className="cursor-pointer whitespace-nowrap transition-all !bg-gray-50 !text-gray-500 !border-gray-200"
                    labelClassName="!text-[12px] !uppercase"
                  />
                )}
                <CustomChip
                  chipType="mono-light"
                  showActionIcon={true}
                  icon={<FaFlask size={12} />}
                  label={t("Lab")}
                  onClick={() => {
                    const url = `/patient-profile/all-reports?patient_id=${mixedData?.patient?.patient_id}&file_no=${mixedData?.patient?.file_no}&document_id=${mixedData?.patient?.document_id}&type=lab`;
                    window.open(url, '_blank');
                  }}
                  className={`cursor-pointer whitespace-nowrap transition-all !px-2 !bg-gray-50 !text-gray-500 !border-gray-200 ${mixedData?.lab_order_status?.toLowerCase().trim() === "approved" ? "!bg-green-500 !text-white !border-green-500" : ["rejected", "cancelled"].includes(mixedData?.lab_order_status?.toLowerCase().trim()) ? "!bg-red-500 !text-white !border-red-500" : ["inprogress", "sample_collected", "samplecollected", "received", "in_progress", "in-progress"].includes(mixedData?.lab_order_status?.toLowerCase().trim()) ? "!bg-sky-100 !text-sky-600 !border-sky-200" : ""}`}
                  labelClassName={`!text-[12px] !uppercase ${["approved", "rejected", "cancelled"].includes(mixedData?.lab_order_status?.toLowerCase().trim()) ? "!text-white" : ["inprogress", "sample_collected", "samplecollected", "received", "in_progress", "in-progress"].includes(mixedData?.lab_order_status?.toLowerCase().trim()) ? "!text-sky-600" : ""}`}
                  actionIconClassName={["approved", "rejected", "cancelled"].includes(mixedData?.lab_order_status?.toLowerCase().trim()) ? "!text-white" : ["inprogress", "sample_collected", "samplecollected", "received", "in_progress", "in-progress"].includes(mixedData?.lab_order_status?.toLowerCase().trim()) ? "!text-sky-600" : ""}
                />
                <CustomChip
                  chipType="mono-light"
                  showActionIcon={true}
                  icon={<FaXRay size={12} />}
                  label={t("imaging")}
                  onClick={() => {
                    const url = `/patient-profile/all-reports?patient_id=${mixedData?.patient?.patient_id}&file_no=${mixedData?.patient?.file_no}&document_id=${mixedData?.patient?.document_id}&type=imaging`;
                    window.open(url, '_blank');
                  }}
                  className={`cursor-pointer whitespace-nowrap transition-all !px-2 !bg-gray-50 !text-gray-500 !border-gray-200 ${["completed", "approved"].includes(mixedData?.radiology_order_status?.toLowerCase().trim()) ? "!bg-green-500 !text-white !border-green-500" : mixedData?.radiology_order_status?.toLowerCase().trim() === "cancelled" ? "!bg-red-500 !text-white !border-red-500" : ["received", "inprogress", "in_progress", "in-progress"].includes(mixedData?.radiology_order_status?.toLowerCase().trim()) ? "!bg-sky-100 !text-sky-600 !border-sky-200" : ""}`}
                  labelClassName={`!text-[12px] !uppercase ${["completed", "approved", "cancelled"].includes(mixedData?.radiology_order_status?.toLowerCase().trim()) ? "!text-white" : ["received", "inprogress", "in_progress", "in-progress"].includes(mixedData?.radiology_order_status?.toLowerCase().trim()) ? "!text-sky-600" : ""}`}
                  actionIconClassName={["completed", "approved", "cancelled"].includes(mixedData?.radiology_order_status?.toLowerCase().trim()) ? "!text-white" : ["received", "inprogress", "in_progress", "in-progress"].includes(mixedData?.radiology_order_status?.toLowerCase().trim()) ? "!text-sky-600" : ""}
                />
                {mixedData?.visit_id && (
                  <CustomChip
                    chipType="mono-light"
                    showActionIcon={true}
                    label={t("History")}
                    onClick={() => {
                      setViewVisitTrack(true);
                      setTrackId(mixedData?.visit_id);
                    }}
                    className="cursor-pointer whitespace-nowrap transition-all !bg-gray-50 !text-gray-500 !border-gray-200"
                    labelClassName="!text-[12px] !uppercase"
                    title={t('Track Visit History')}
                  />
                )}
                <CustomChip
                  chipType="mono-light"
                  showActionIcon={true}
                  label={t("Journey")}
                  onClick={() => setViewJourney(true)}
                  className="cursor-pointer whitespace-nowrap transition-all !bg-primary/5 !text-primary !border-primary/20"
                  labelClassName="!text-[12px] !uppercase"
                  title={t('Patient Journey Timeline')}
                />
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <VisitCreateActionsMenu visitData={mixedData} />
                {/* {mixedData?.status === "Cancelled" ? (
                  <CustomChip
                    chipType="soft-danger"
                    label={t("Cancelled")}
                    className="whitespace-nowrap transition-all"
                    labelClassName="!text-[12px] !uppercase"
                  />
                ) : ( */}
                {mixedData?.status !== "Cancelled" && !mixedData?.emr_numbers?.length &&
                  !isBusiness42ReceptionistUser &&
                  hasPermission("visit", "update") && (
                    <ActionButton
                      variant="danger"
                      icon={<MdCancel />}
                      onClick={() => setOpenCancelVisitModal(true)}
                      title={t("Cancel Visit")}
                    />
                  )
                /* ) */}
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-start lg:justify-end px-3 py-2 gap-2 flex-1 h-auto">
              <CustomChip
                chipType="mono-outline"
                showActionIcon={true}
                label={t("Medical Summary")}
                onClick={() => {
                  let patientData = { ...mixedData?.patient, visit_id: mixedData?.visit_id };
                  dispatch(setIsGeneralSearch(false));
                  dispatch(setSelectPatientData(patientData));
                  dispatch(setSelectedVisitData(mixedData));
                  navigate("/patient-profile/emr");
                }}
                className="cursor-pointer whitespace-nowrap transition-all !bg-gray-50 !text-gray-500 !border-gray-200"
                labelClassName="!text-[12px] !uppercase"
              />

              <CustomChip
                chipType="mono-outline"
                label={mixedData?.priority?.coding?.[0]?.display || "NORMAL"}
                className={`whitespace-nowrap transition-all ${isEmergencyVisit ? "!bg-orange-200 !text-orange-600 !border-orange-500" : "!bg-gray-50 !text-gray-500 !border-gray-200"}`}
                labelClassName="!text-[12px] !uppercase"
              />

              {mixedData?.visit_category === "special_patient" && (
                <CustomChip
                  chipType="mono-light"
                  label={t("SPECIAL PATIENT")}
                  className="whitespace-nowrap transition-all !bg-yellow-100 !text-yellow-600 !border-yellow-500"
                  labelClassName="!text-[12px] !uppercase"
                />
              )}
              <CustomChip
                chipType="mono-light"
                label={mixedData?.episode_type}
                className={`whitespace-nowrap transition-all ${["first visit", "special visit"].includes(mixedData?.episode_type?.toLowerCase())
                  ? "!bg-blue/10 !text-blue !border-blue"
                  : mixedData?.episode_type?.toLowerCase() === "follow up"
                    ? "!bg-yellow-100 !text-yellow-600 !border-yellow-500"
                    : "!bg-gray-50 !text-gray-500 !border-gray-200"
                  }`}
                labelClassName="!text-[12px] !uppercase"
              />
            </div>

            <div className="flex flex-wrap items-center justify-start lg:justify-end gap-2 px-3 py-2 border-t border-gray-100 mt-auto bg-gray-50/50 h-auto min-h-[45px]">
              <div className="flex items-center gap-1.5">
                {hasPermission("emr", "get") && mixedData?.emr_numbers?.length > 0 && (
                  <>
                    <ActionButton
                      disabled={viewEmrLoading}
                      loading={viewEmrLoading}
                      icon={<FaFilePrescription />}
                      variant="primary"
                      onClick={() => !viewEmrLoading && handleViewEmrDetails(mixedData?.emr_numbers?.[0])}
                      title={t("Medical Summary")}
                    />
                    <ActionButton
                      disabled={viewEmrLoading}
                      loading={viewEmrLoading}
                      variant="primary"
                      icon={<FaPills />}
                      onClick={() => !viewEmrLoading && handlePrescriptionDetails(mixedData?.emr_numbers?.[0])}
                      title={t("Prescription")}
                    />
                    {getClinicalOrderItems(mixedData?.items, "laboratory").length > 0 && (
                      <ActionButton
                        disabled={viewEmrLoading}
                        loading={viewEmrLoading}
                        variant="primary"
                        icon={<FaFlask />}
                        onClick={() => !viewEmrLoading && handleClinicalOrderDetails("laboratory")}
                        title={t("Laboratory Order")}
                      />
                    )}
                    {getClinicalOrderItems(mixedData?.items, "imaging").length > 0 && (
                      <ActionButton
                        disabled={viewEmrLoading}
                        loading={viewEmrLoading}
                        variant="primary"
                        icon={<FaXRay />}
                        onClick={() => !viewEmrLoading && handleClinicalOrderDetails("imaging")}
                        title={t("Radiology / Imaging Order")}
                      />
                    )}
                  </>
                )}

                {hasPermission("visit", "create") && mixedData?.status === "Cancelled" && endTime.isAfter(currentTime, "minute") && (
                  <ActionButton
                    variant="primary"
                    icon={<MdOutlineAdd />}
                    onClick={handleNavigateCreateVisit}
                    title={t("New Visit")}
                  />
                )}

                {Array.isArray(mixedData?.reference_invoice_number) && mixedData?.reference_invoice_number?.length > 0 && isReceptionist && (
                  <div className="relative group">
                    <DropdownField
                      useFormik={false}
                      placeholder={
                        <div className="flex items-center gap-1">
                          <FaFileInvoiceDollar size={14} className="text-primary group-hover:text-primary transition-colors" />
                          <span className="text-[10px] font-semibold text-primary uppercase md:block hidden">{t("Invoices")}</span>
                        </div>
                      }
                      className="!w-auto !h-[24px] md:!h-[28px] !mb-0 visit-card-dropdownfield-simple"
                      options={mixedData?.reference_invoice_number?.map(v => ({ label: v?.cash_invoice_number, value: v?.invoice_number }))}
                      handleChange={e => navigate(`/print-invoice/${e.target.value}`, {
                        state: {
                          invoiceNumber: e.target.value,
                          state: {
                            file_no: mixedData?.patient?.file_no,
                            document_id: mixedData?.patient?.document_id,
                            // cash_invoice_number:e?.target?.value
                          },
                        }
                      })}
                      ptOptions={{
                        root: { className: '!h-[24px] md:!h-[28px] !min-h-[24px] md:!min-h-[28px] flex items-center !rounded-[6px] !bg-white !border !border-gray-200 hover:!border-gray-300 transition-all !px-2 ' },
                        input: { className: 'hidden' },
                        trigger: { className: '!w-full flex items-center justify-center gap-2' },
                        dropdownicon: { className: '!w-[8px] md:!w-[10px] !h-[8px] md:!h-[10px] !text-gray-400 group-hover:!text-gray-600' },
                        item: { className: 'capitalize !outline-none text-[10px] md:text-[11px]' }
                      }}
                    />
                  </div>
                )}

                {hasPermission("emr", "update") && mixedData?.emr_numbers?.length > 0 && canEditEmr(mixedData, isDoc) && (emrCreationCheck || ["Follow Up", "Follow up"].includes(mixedData?.visit_type?.type)) && mixedData?.emr_numbers?.map((d, i) => (
                  <ActionButton
                    key={i}
                    icon={<MdEditNote />}
                    variant="primary"
                    onClick={() => {
                      dispatch(setSelectPatientData(mixedData?.patient));
                      dispatch(setSelectedVisitData(mixedData));
                      navigateSecurely(navigate, "/patient-profile/edit-emr", { emr_id: d, visitData: mixedData });
                    }}
                    title={t("EditEMR")}
                  />
                ))}

                {!mixedData?.emr_numbers?.length && mixedData?.status !== "Cancelled" && (emrCreationCheck || ["Follow Up", "Follow up"].includes(mixedData?.visit_type?.type)) && hasPermission("emr", "create") && (
                  <ActionButton
                    variant="primary"
                    icon={<MdNoteAdd />}
                    onClick={() => {
                      navigateSecurely(navigate, "/patient-profile/create-emr", { visitData: mixedData });
                      dispatch(setSelectPatientData(mixedData?.patient));
                      dispatch(setIsGeneralSearch(false));
                      dispatch(setSelectedVisitData(mixedData));
                    }}
                    title={t("CreateEMR")}
                  />
                )}

                {mixedData?.status !== "Cancelled" && hasPermission("pay-bill", "create") && (
                  <ActionButton
                    variant="primary"
                    icon={<FaMoneyBill1Wave />}
                    onClick={handlePayBill}
                    title={t("Pay Bill")}
                  />
                )}
                <VisitCreateActionsMenu visitData={mixedData} printActions />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col w-full gap-5 items-center justify-center min-h-[100px] overflow-x-auto relative scrollbar">
          <p className="text-16-gray">
            {visitCategory === "out_patient" ||
              (visitCategory === "out_patient" &&
                mixedData?.visit_category === "special_patient")
              ? t("This slot is Booked for In Patient")
              : t("This slot is Booked for Out Patient")}
          </p>
        </div>
      )}

      <ReusableModal
        isVisible={extendModal}
        title={t("Extend Visit Time")}
        HeaderIcon={IoTimeOutline}
        position="top"
        onClose={() => {
          setExtendModal(false);
          setExtendedVisit(null);
        }}
      >
        <ExtednVisitTime
          visit={extendedVisit}
          setExtendModal={setExtendModal}
          setExtendedVisit={setExtendedVisit}
          getVisitDataPayload={getVisitDataPayload}
        />
      </ReusableModal>
      <ReusableModal
        isVisible={openCancelVisitModal}
        title={t("CancelVisit")}
        HeaderIcon={MdOutlineCancel}
        position="top"
        onClose={() => {
          setOpenCancelVisitModal(false);
        }}
      >
        <CancelVisitForm
          getVisitDataPayload={getVisitDataPayload}
          setOpenCancelVisitModal={setOpenCancelVisitModal}
          visitData={mixedData}
        />
      </ReusableModal>
      <ReusableModal
        position="top"
        isVisible={openViewEmrModal}
        title={t("emr_details")}
        HeaderIcon={FaBriefcaseMedical}
        onClose={() => {
          setOpenViewEmrModal(false);
          setSelectedEmrData(null);
        }}
        className="w-full lg:w-[850px] relative"
      >
        <EmrDetails emrData={selectedEmrData} />
      </ReusableModal>
      <ReusableModal
        className="w-full md:w-[800px] lg:w-[1000px] h-[90vh] relative"
        isVisible={viewSickLeave}
        title={t("Sick Leave Report")}
        position="top"
        onClose={() => {
          setViewSickLeave(false);
          setSelectedEmrData(null);
        }}
      >
        <ViewSickeLeaveReport selectedLeaveData={selectedEmrData} />
      </ReusableModal>
      <ReusableModal
        position="top"
        isVisible={viewItems}
        title={t("Items")}
        HeaderIcon={FaBox}
        onClose={() => {
          setViewItems(false);
          setSelectedEmrData(null);
        }}
        className="w-full lg:w-[95%] relative"
        messagePaid={true}
      >
        <ViewItems visitData={selectedEmrData} />
      </ReusableModal>
      <ReusableModal
        position="top"
        isVisible={openViewPrescriptionModal}
        title={t("Prescription")}
        HeaderIcon={FaBriefcaseMedical}
        onClose={() => {
          setOpenViewPrescriptionModal(false);
          setSelectedEmrData(null);
        }}
        className="w-full lg:w-[850px] relative"
      >
        <Prescription emrData={selectedEmrData} />
      </ReusableModal>
      <ReusableModal
        position="top"
        isVisible={Boolean(clinicalOrderReportType)}
        title={clinicalOrderReportType === "imaging" ? t("Radiology / Imaging Order") : t("Laboratory Order")}
        HeaderIcon={clinicalOrderReportType === "imaging" ? FaXRay : FaFlask}
        onClose={() => {
          setClinicalOrderReportType(null);
          setSelectedEmrData(null);
        }}
        className="w-full lg:w-[1000px] relative"
      >
        <ClinicalOrderReport emrData={selectedEmrData} reportType={clinicalOrderReportType} />
      </ReusableModal>
      <ReusableModal
        position="top"
        isVisible={viewVisitTrack}
        title={t("Visit Tracking")}
        HeaderIcon={FaRoute}
        onClose={() => {
          setViewVisitTrack(false);
          setTrackId(null);
        }}
        className="w-full lg:w-[95%] relative"
      >
        <TrackingContent trackType={'visit'} trackId={trackId} t={t} />
      </ReusableModal>

      <PatientJourneyModal
        visible={viewJourney}
        onClose={() => setViewJourney(false)}
        patientId={mixedData?.patient?.patient_id}
        fileNumber={mixedData?.patient?.file_no || mixedData?.patient?.file_number}
        documentId={mixedData?.patient?.document_id}
        visitId={mixedData?.visit_id}
      />
    </>
  );
};

export default MixedAppointmentVisitCard;
